/*eslint-disable*/
import React from "react";
import {
  Flex,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
export default function Footer() {
  let textColor = useColorModeValue("gray.400", "white");
  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: "column",
        lg: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='space-between'
      px={{ base: "30px", md: "0px" }}
      pb='30px'>
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", lg: "0px" }}>
        &copy; {1900 + new Date().getYear()} {process.env.REACT_APP_NAME}. Tutti i diritti riservati.{" "}
        <Link
          as={NavLink}
          to='/privacy-policy'
          color='brand.500'
          _hover={{ color: "brand.600" }}
          transition='color 0.2s linear'>
          Informativa Privacy
        </Link>
      </Text>
    </Flex>
  );
}
